module.exports = __webpack_public_path__ + "img/tubiao-08.eaff9bf8.png";